import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DisplayService, IDialogOptionsJson } from "@services/display.service";
import { TranslationService } from "@services/translation.service";
import './delete-confirm.component.scss';

@Component({
    selector: 'delete-confirmation',
    template: require('./delete-confirm.component.html')
})
export class DeleteConfirmationComponent {

    @Input() inlineConfirm: boolean;
    @Input() small: boolean;
    @Input() isDisabled: boolean;
    @Input() loading: boolean;

    @Input() subjectName: string;
    @Input() subjectVerb: string;
    @Input() reference: string;
    @Input() label: string;
    @Input() icon: string = "delete";

    @Input() cancelVerb: string = this.translationService.t("Common.Cancel");

    @Output() onConfirm = new EventEmitter<boolean>();

    showDeleteConfirm = false;

    constructor(
        protected readonly displayService: DisplayService,
        protected readonly translationService: TranslationService) { }


    onDeleteClick($event) {
        if (this.inlineConfirm) {
            this.showDeleteConfirm = true;
        }
        else {
            this.showDeleteDialog($event);
        }
    }

    showDeleteDialog($event) {
        let dialogHTML = `<veri-panel class="delete-confirm-dialog"><div class="confirm-message">${this.translationService.t('DeleteConfirm.AreYouSure', [this.subjectVerb.toLowerCase(), this.subjectName.toLowerCase()])}</div><div class="footer"><v-button class="md-secondary" ng-click="$ctrl.onConfirmDialog(false); $ctrl.hide();">${this.cancelVerb}</v-button><v-button class="danger primary" ng-click="$ctrl.onConfirmDialog(true); $ctrl.hide()">${this.subjectVerb}</v-button></div></veri-panel>`;

        const dialogOptions: IDialogOptionsJson = {
            title: `${this.subjectVerb} ${this.subjectName}?`,
            dialogHTML: dialogHTML,
            dialogId: `deleteConfirmDialog`,
            bindings: {
                onConfirmDialog: (confirmation: boolean) => { this.onConfirmDialog(confirmation); }
            },
            event: $event,
            multiple: true,
            clickOutsideToClose: true,
            escapeToClose: true
        };

        this.displayService.showDialog(dialogOptions);

    }

    onConfirmDialog(confirmation: boolean) {
        this.onConfirm.emit(confirmation);
    }

}
